import React, { Component } from 'react'
import {
    Row,
    Col,
    Button,
    Upload,
    Spin,
    Pagination,
    Table,
    Select,
    Input,
    InputNumber,
    Icon,
    Modal,
    DatePicker
} from 'antd'
import moment from "moment"
import { app, config, api } from "../../app"
import FormModal from "../../components/FormModal2"
import locale from "antd/lib/date-picker/locale/zh_CN"
import utils from "../../utils"

const Option = Select.Option

function beforeUpload (file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png']
    const is = format.indexOf(file.type) > -1
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn')
        return Promise.reject()
    }
    return Promise.resolve()
}

class TETeamEquipment extends Component {
    constructor (props) {
        super(props)
        this.state = {
            show: 0,
            total: 0,
            page: 1,
            rtotal: 0,
            rpage: 1,
            detailInfo: null,
            recordList: [],
            equipList: [],
            classList: [],
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleData()
        await this.handleClassData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    async componentWillReceiveProps (props) {
        let { team } = this.props
        if (team.teamno !== props.team.teamno) {
            await this.setData({ equipList: [], total: 0 })
            await this.handleData(1)
        }
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 来源数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleClassData = async () => {
        await this.setData({ class_loading: true })
        let params = {
            class_type: 2,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.OpenClassData, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        this.setData({ class_loading: false, classList: data })
    }

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, show: 0 })
        let { team } = this.props,
            params = {
                page,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamEquipList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            this.setData({
                equipList: data,
                show: 1,
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 操作记录数据处理
     * @param rpage
     * @returns {Promise<void>}
     */
    handleRecordData = async (rpage = 1) => {
        await this.setData({ rpage, record_loading: true })
        let { team } = this.props,
            params = {
                page: rpage,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamEquipOperateList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (rpage === this.state.rpage) {
            this.setData({
                record_loading: false,
                recordList: utils.addArrayKey(data),
                rtotal: parseInt(total || 0),
            })
        }
    }

    handleBack = async (show) => {
        if (show === 1) {
            await this.setData({ show: 2 })
            await this.handleRecordData()
        } else if (show === 2) {
            this.setState({ show: 1 })
        }
    }

    /**
     * 关闭添加框
     * @param e
     */
    handleCloseAddModal = () => {
        this.setData({ add_visible: false })
    }

    /**
     * 打开添加框
     * @param e
     */
    handleOpenAddModal = () => {
        this.setData({ add_visible: true })
    }

    /**
     * 关闭详情框
     * @param e
     */
    handleCloseDetailModal = () => {
        this.setData({ detail_visible: false })
    }

    /**
     * 打开编辑框
     * @param e
     */
    handleOpenEditModal = () => {
        this.setData({ detail_visible: false, edit_visible: true })
    }

    /**
     * 关闭编辑框
     * @param e
     */
    handleCloseEditModal = () => {
        this.setData({ edit_visible: false })
    }

    /**
     * 打开详情框
     * @param id
     * @param is_operate
     */
    handleOpenDetailModal = async (id, is_operate) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        let { flag, data, msg } = await app.post(api.TeamEquipDetails, { id })
        let state = { detail_loading: false }
        if (flag === 1) {
            data.is_operate = is_operate
            state.detailInfo = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    normFile = (e) => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    /**
     * 添加
     * @param values
     */
    handleAdd = async (values) => {
        await this.setData({ add_loading: true })
        let imgs = []
        for (let i = 0; i < values.equip_img.length; i++) {
            let file = values.equip_img[i]
            if (file.response && file.response.flag === 1) {
                imgs.push(file.response.data.url)
            }
        }
        let { team } = this.props
        values.indexno = app.getData("indexno")
        values.account = app.getData("account")
        values.teamno = team.teamno
        values.equip_img = imgs.join(":::")
        let { flag, msg } = await app.post(api.TeamEquipAdd, values)
        await this.setData({ add_loading: false })
        if (flag === 1) {
            app.alert("添加成功", "success")
            this.handleCloseAddModal()
            await this.handleData()
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 删除
     * @param id
     * @returns {Promise<void>}
     */
    handleDel = async (id) => {
        await this.setData({ del_loading: true })
        let { flag, msg } = await app.post(api.TeamEquipDel, {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        })
        await this.setData({ del_loading: false })
        if (flag === 1) {
            app.alert("删除成功", "success")
            await this.handleCloseDetailModal()
            await this.handleData()
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 编辑
     * @param values
     * @returns {Promise<void>}
     */
    handleEdit = async (values) => {
        await this.setData({ edit_loading: true })
        let imgs = []
        for (let i = 0; i < values.equip_img.length; i++) {
            let file = values.equip_img[i]
            if (file.response && file.response.flag === 1) {
                imgs.push(file.response.data.url)
            }
        }
        values.indexno = app.getData("indexno")
        values.account = app.getData("account")
        values.equip_img = imgs.join(":::")
        values.equip_overhaul_time = values.equip_overhaul_time.format("YYYY-MM-DD")
        let { flag, msg } = await app.post(api.TeamEquipSave, values)
        await this.setData({ edit_loading: false })
        if (flag === 1) {
            app.alert("编辑成功", "success")
            await this.handleCloseEditModal()
            await this.handleData()
        } else {
            app.alert(msg, "error")
        }
    }

    render () {
        let { show, equipList, total, page, rtotal, rpage, class_loading, classList, detail_visible, detailInfo, del_loading, edit_visible, edit_loading, add_visible, add_loading, record_loading, recordList } = this.state,
            formItemLayout = {
                labelCol: { span: 3 },
                wrapperCol: { span: 20, offset: 1 },
            },
            columns = [
                {
                    title: '操作时间',
                    dataIndex: 'work_time',
                    key: 'work_time',
                    width: '15%'
                },
                {
                    title: '装备名称',
                    dataIndex: 'work_title',
                    key: 'work_title',
                    width: '20%'
                },
                {
                    title: '操作前',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '20%'
                },
                {
                    title: '操作后',
                    dataIndex: 'work_after',
                    key: 'work_after',
                    width: '20%'
                },
                {
                    title: '操作类型',
                    dataIndex: 'work_status',
                    key: 'work_status',
                    width: '15%',
                    render (status, { update_type }) {
                        let text = ''
                        switch (status) {
                            case '1':
                                text = '添加'
                                break
                            case '2':
                                text = '编辑'
                                break
                            case '3':
                                text = '删除'
                                break
                            default:
                                text = ''
                                break
                        }
                        return text + update_type
                    }
                },
                {
                    title: '操作人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '10%'
                },
            ]
        return (
            <div className="team-equipment">
                <div className="head">
                    <div className="btn">
                        <Button hidden={show !== 2} onClick={() => this.handleBack(show)}>返回</Button>
                    </div>
                    <h2 className="title">队伍装备</h2>
                    <div className="btn" style={{ textAlign: "right" }} hidden={show !== 1}>
                        <Button style={{ margin: "0 20px" }} onClick={() => this.handleBack(show)}>操作记录</Button>
                        <Button onClick={() => this.handleOpenAddModal()}>添加装备</Button>
                    </div>
                </div>
                <Row className="loading" type="flex" justify="center" align="middle" hidden={show}><Spin/></Row>
                <div className="te-all" gutter={10} hidden={show !== 1}>
                    {
                        equipList.length > 0 ?
                            (
                                [
                                    <Row className="te-items" gutter={10} key="1">
                                        {
                                            equipList.map((equip, i) => {
                                                return (
                                                    <Col span={6} key={i} className="te-item"
                                                         onClick={() => this.handleOpenDetailModal(equip.id, equip.is_operate)}>
                                                        <div className="img">
                                                            <img src={config.imgUrl + equip.equip_img} alt=""/>
                                                        </div>
                                                        <div className="title">{equip.equip_name}</div>
                                                        <div className="count">已报废: {equip.equip_scrapped_num}</div>
                                                        <div className="count">数量: {equip.equip_num}</div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>,
                                    <div style={{ textAlign: "right" }} key="2">
                                        <Pagination total={total} size="small" pageSize={20} current={page}
                                                    showTotal={(total) => `总数量：${total}`}
                                                    onChange={this.handleData}/>
                                    </div>
                                ]
                            ) :
                            (<Row className="loading" type="flex" justify="center" align="middle">暂无装备</Row>)
                    }
                </div>
                <div style={{ height: 'calc(100% - 41.5px)' }} hidden={show !== 2}>
                    <Table columns={columns}
                           locale={app.tbLocale(record_loading)}
                           dataSource={recordList}
                           loading={record_loading}
                           scroll={{ y: 'calc(100% - 103px)' }}
                           style={{ height: '100%', margin: 0 }}
                           className="ranks_table"
                           pagination={false}
                           size="small"
                           footer={recordList.length === 0 ? null : () => {
                               return (
                                   <div style={{ textAlign: 'right' }}>
                                       <Pagination total={rtotal} size="small" pageSize={20} current={rpage}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handleRecordData}/>
                                   </div>
                               )
                           }}
                    />
                </div>
                <FormModal
                    modal={{
                        visible: add_visible,
                        title: "添加装备",
                        onCancel: this.handleCloseAddModal,
                        okText: "确认",
                        cancelText: "取消",
                        width: 800,
                        confirmLoading: add_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                    }}
                    onSubmit={this.handleAdd}
                >
                    {
                        [
                            {
                                formItemLayout,
                                label: "装备名称",
                                name: "equip_name",
                                options: {
                                    rules: [
                                        { required: true, message: '请输入名称' },
                                    ]
                                },
                                component: (
                                    <Input placeholder="装备名称"/>
                                )
                            },
                            {
                                formItemLayout,
                                label: "装备来源",
                                name: "class_id",
                                options: {
                                    rules: [
                                        { required: true, message: '请选择来源' },
                                    ]
                                },
                                component: (
                                    <Select placeholder="请选择"
                                            notFoundContent={class_loading ? <Spin size="small"/> : "暂无数据"}>
                                        {
                                            classList.map((cla, index) => {
                                                return (
                                                    <Option key={index} value={cla.id}>{cla.open_class_name}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )
                            },
                            {
                                formItemLayout,
                                label: "装备数量",
                                name: "equip_num",
                                options: {
                                    rules: [
                                        { required: true, message: '请输入数量' },
                                    ]
                                },
                                component: (
                                    <InputNumber placeholder="数量" min={1}/>
                                )
                            },
                            {
                                formItemLayout,
                                label: "装备图片",
                                name: "equip_img",
                                options: {
                                    rules: [
                                        { required: true, message: '请上传图片' },
                                    ],
                                    valuePropName: 'fileList',
                                    getValueFromEvent: this.normFile,
                                },
                                component: (
                                    <Upload
                                        action={config.serverUrl + api.ImageUpload}
                                        accept='image/jpeg, image/jpg, image/png'
                                        data={{
                                            indexno: app.getData('indexno'),
                                            account: app.getData('account'),
                                            token: app.getData('token'),
                                            upload_type: 'team',
                                        }}
                                        name="image"
                                        multiple={true}
                                        beforeUpload={beforeUpload}
                                        listType="picture"
                                        className="upload-list-inline"
                                    >
                                        <Button>
                                            <Icon type="upload"/> 点击上传
                                        </Button>
                                    </Upload>
                                )
                            }
                        ]
                    }
                </FormModal>
                <FormModal
                    modal={{
                        visible: edit_visible,
                        title: "编辑装备",
                        onCancel: this.handleCloseEditModal,
                        okText: "确认",
                        cancelText: "取消",
                        width: 800,
                        confirmLoading: edit_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                    }}
                    onSubmit={this.handleEdit}
                >
                    {
                        detailInfo ?
                            [
                                {
                                    label: "",
                                    name: "id",
                                    options: {
                                        initialValue: detailInfo.id
                                    },
                                    component: (
                                        <Input type="hidden"/>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "装备名称",
                                    name: "equip_name",
                                    options: {
                                        rules: [
                                            { required: true, message: '请输入名称' },
                                        ],
                                        initialValue: detailInfo.equip_name
                                    },
                                    component: (
                                        <Input placeholder="装备名称"/>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "装备来源",
                                    name: "equip_source",
                                    options: {
                                        rules: [
                                            { required: true, message: '请选择来源' },
                                        ],
                                        initialValue: detailInfo.equip_source_id
                                    },
                                    component: (
                                        <Select placeholder="请选择"
                                                notFoundContent={class_loading ? <Spin size="small"/> : "暂无数据"}>
                                            {
                                                classList.map((cla, index) => {
                                                    return (
                                                        <Option key={index}
                                                                value={cla.id}>{cla.open_class_name}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "装备数量",
                                    name: "equip_num",
                                    options: {
                                        rules: [
                                            { required: true, message: '请输入数量' },
                                        ],
                                        initialValue: detailInfo.equip_num || undefined
                                    },
                                    component: (
                                        <InputNumber placeholder="数量" min={1}/>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "报废数量",
                                    name: "equip_scrapped_num",
                                    options: {
                                        rules: [
                                            { required: true, message: '请输入数量' },
                                        ],
                                        initialValue: detailInfo.equip_scrapped_num || 0
                                    },
                                    component: (
                                        <InputNumber min={0} placeholder="数量"/>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "上次检修日期",
                                    name: "equip_overhaul_time",
                                    options: {
                                        rules: [
                                            { required: true, message: '请选择检修时间' },
                                        ],
                                        initialValue: detailInfo.equip_overhaul_time ? moment(detailInfo.equip_overhaul_time) : undefined
                                    },
                                    component: (
                                        <DatePicker
                                            disabledDate={(current) => current && current > moment().endOf('day')}
                                            placeholder="请选择" locale={locale}/>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "装备图片",
                                    name: "equip_img",
                                    options: {
                                        rules: [
                                            { required: true, message: '请上传图片' },
                                        ],
                                        valuePropName: 'fileList',
                                        getValueFromEvent: this.normFile,
                                        initialValue: detailInfo.equip_img.map((img, i) => {
                                            i += 1
                                            return {
                                                uid: i - i * 2,
                                                status: 'done',
                                                response: {
                                                    flag: 1,
                                                    data: {
                                                        url: img
                                                    }
                                                },
                                                name: "图片" + i,
                                                thumbUrl: config.imgUrl + img
                                            }
                                        })
                                    },
                                    component: (
                                        <Upload
                                            action={config.serverUrl + api.ImageUpload}
                                            accept='image/jpeg, image/jpg, image/png'
                                            data={{
                                                indexno: app.getData('indexno'),
                                                account: app.getData('account'),
                                                token: app.getData('token'),
                                                upload_type: 'team',
                                            }}
                                            name="image"
                                            multiple={true}
                                            beforeUpload={beforeUpload}
                                            listType="picture"
                                            className="upload-list-inline"
                                        >
                                            <Button>
                                                <Icon type="upload"/> 点击上传
                                            </Button>
                                        </Upload>
                                    )
                                }
                            ] : []
                    }
                </FormModal>
                <Modal
                    visible={detail_visible}
                    title="装备详情"
                    onCancel={this.handleCloseDetailModal}
                    okText="确认"
                    cancelText="取消"
                    width={800}
                    maskClosable={false}
                    destroyOnClose={true}
                    footer={<div>
                        <Button onClick={() => this.handleOpenEditModal()}
                                hidden={detailInfo && detailInfo.is_operate !== 1}>编辑</Button>
                        <Button onClick={() => this.handleDel(detailInfo.id)}
                                hidden={detailInfo && detailInfo.is_operate !== 1} loading={del_loading}>删除</Button>
                        <Button onClick={() => this.handleCloseDetailModal()}>取消</Button>
                    </div>}
                    bodyStyle={{ overflow: "auto", height: "calc(100% - 108px)" }}
                    className="team-equipment-detail-modal"
                >
                    {
                        detailInfo ?
                            <div>
                                <Row className="item">
                                    <Col span={4}>装备名称</Col>
                                    <Col span={20}>{detailInfo.equip_name}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4}>装备来源</Col>
                                    <Col span={20}>{detailInfo.equip_source}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4}>装备数量</Col>
                                    <Col span={20}>{detailInfo.equip_num}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4}>报废数量</Col>
                                    <Col span={20}>{detailInfo.equip_scrapped_num}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4}>添加时间</Col>
                                    <Col span={20}>{detailInfo.submit_time}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4}>上次检修日期</Col>
                                    <Col span={20}>{detailInfo.equip_overhaul_time || '-'}</Col>
                                </Row>
                                <div className="item-img">
                                    <div>装备图片</div>
                                    <div className="imgs">
                                        {
                                            (detailInfo.equip_img || []).map((img, i) => {
                                                return (
                                                    <div className="img" key={i}><img src={config.imgUrl + img} alt=""/>
                                                    </div>)
                                            })
                                        }
                                    </div>
                                </div>
                            </div> : null
                    }
                </Modal>
            </div>
        )
    }
}

export default TETeamEquipment



// WEBPACK FOOTER //
// ./src/routes/ranks/TETeamEquipment.jsx